import {Route, Routes, Outlet} from 'react-router-dom'
import {DynamicList} from './components/DynamicList'

interface IDynamicParams {
  isDisplayed?: boolean
  showMap?: (show: boolean) => void
  mapList?: (map: any[]) => void
}

export const TabList = ({isDisplayed, showMap, mapList}: IDynamicParams) => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/:accesscode'
          element={
            <>
              <DynamicList
                isPrimary={true}
                isDisplayed={isDisplayed}
                showMap={(show) => showMap && showMap(show)}
                mapList={(map) => mapList && mapList(map)}
              />
            </>
          }
        />
      </Route>
      <Route element={<Outlet />}>
        <Route
          path='/:accesscode/:sysparam'
          element={
            <>
              <DynamicList
                isPrimary={true}
                isDisplayed={isDisplayed}
                showMap={(show) => showMap && showMap(show)}
                mapList={(map) => mapList && mapList(map)}
              />
            </>
          }
        />
      </Route>
    </Routes>
  )
}
